import * as React from 'react';
import {
  Box,
  Users,
  Edit  ,
  UserPlus,
  Home,
  Phone,
} from 'react-feather';
import { UserRole } from '../generated/graphql';
import { IS_VENDOR } from '../consts/index';
import { theme } from '../theme';

const color = IS_VENDOR ? theme.colors.charcoalGrey : 'white';

const disabledSideNavItems = [
  '/team',
  '/calendars/resource',
  '/resources/active',
  '/services',
  '/bookings',
  '/categories/categories',
  '/social-groups',
  '/properties',
  '/events',
  '/foundations',
  '/foundations/foundations',
  '/events/all',
];

export const DUMMY_NAV_ITEMS = [
  {
    to: '/dashboard',
    parent: '/dashboard',
    title: 'Dashboard',
    icon: <Box size={20} color={color} className="sidebar-menu-icon" />,
    permissions: [UserRole.Admin, UserRole.Superadmin],
  },
  {
    to: '/properties',
    parent: '/properties',
    title: 'Properties',
    icon: <Home size={20} color={color} className="sidebar-menu-icon" />,
    permissions: [UserRole.Admin, UserRole.Superadmin, UserRole.StakeholderAdmin],
  },
  {
    to: '/stakeholders/all',
    parent: '/stakeholders',
    title: 'Stakeholders',
    icon: <Users size={20} color={color} className="sidebar-menu-icon" />,
    permissions: [UserRole.Admin, UserRole.Superadmin, UserRole.StakeholderAdmin],
  },
  {
    to: '/content-management/notifications',
    parent: '/content-management',
    title: 'Content Management',
    icon: <Edit size={20} color={color} className="sidebar-menu-icon" />,
    permissions: [UserRole.Admin, UserRole.Superadmin, UserRole.ContentAdmin],
  },
  {
    to: '/user-management',
    parent: '/user-management',
    title: 'User Management',
    icon: <UserPlus size={20} color={color} className="sidebar-menu-icon" />,
    permissions: [UserRole.Admin, UserRole.Superadmin],
  },
  {
    to: '/contact-us',
    parent: '/contact-us',
    title: 'Contact Us',
    icon: <Phone size={20} color={color} className="sidebar-menu-icon" />,
    permissions: [UserRole.Admin, UserRole.Superadmin, UserRole.ContentAdmin],
  },
].filter((sideNavItem) => !disabledSideNavItems.includes(sideNavItem.to));



// WEBPACK FOOTER //
// ./src/navigation/NavItems.tsx